export default {
  day: 'jour',
  freeTimesLimitTitle: "L'essai du compte gratuit s'achève aujourd'hui.",
  fileSizeLimitTitle:
    'La taille du fichier pour le compte gratuit ne peut excéder 20 Mo.',
  total: 'Tous',
  enterCode: 'Entrez le code',
  signUpToPurchaseBtn: 'Inscrivez-vous et acheter',
  goPurchseBtn: "Aller à l'achat",
  saveTips: "Économisez jusqu'à {{num}} %",
  discount: 'Remises',
  montly: 'Mensuel',
  yearly: 'Chaque année',
  weekly: 'Hebdomadaire',
  week: 'Semaine',
  priceWeek: '9,99€',
  priceMonth: '7,49€',
  priceYearly: '3,75€',
  billMonth: '29,99 € Facturé mensuellement',
  billYear: '179,99 € Facturé annuellement',
  AlreadySubscribe: 'Déjà inscrit?',
  vipTips1: 'Aucune limite de taille de fichier',
  vipTips2: 'Nombre illimité de fichiers à traiter',
  vipTips3: "Modifier l'arrière-plan des images sans limite",
  vipTips4: 'Accès à tous les outils gratuits et aux fonctionnalités premium',
  purchaseTips: 'Renouvellement automatique et annulation à tout moment',
  tips: 'Note:',
  promoCodeInvalidTips: "Votre code promo n'est pas valide",
};
